import { createSelector } from '@ngrx/store';
import { userRegisterSelector } from './user-register.reducer';

export const selectIncludeInactive = createSelector(userRegisterSelector, (state) => {
   return state.includeInactive;
});

export const selectFilters = createSelector(userRegisterSelector, (state) => {
   return state.filters;
});

export const selectIsOnSystemPage = createSelector(userRegisterSelector, (state) => {
   return state.isOnSystemPage;
});
